import React, { Component } from "react";
import { withRouter, Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import {getMessagemErro} from "../../utils/erro";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import api from "../../services/api";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import './SolicitacaoCadastroArquivosGrandesVolumes.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowTrendUp, faClipboardCheck, faFilePen, faFolderClosed, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { 	SITUACAO_SOLICITACAO_RASCUNHO, SITUACAO_SOLICITACAO_EM_ANALISE_GESTOR_PLATAFORMA,
			SITUACAO_SOLICITACAO_DEFERIDA,
			SITUACAO_SOLICITACAO_REJEITADA_GESTOR_PLATAFORMA,
			SITUACAO_SOLICITACAO_CONFIGURANDO_PASTA_SEGURA
 } from "../../providers/constSituacoesSolicitacao";
import { baixarArquivo } from "../../utils/downloadUtil";
import { ConfirmationModal } from "../UI/ConfirmationModal/ConfirmationModal";

const todasSituacoes = [
	SITUACAO_SOLICITACAO_RASCUNHO,
	SITUACAO_SOLICITACAO_EM_ANALISE_GESTOR_PLATAFORMA,
	SITUACAO_SOLICITACAO_DEFERIDA,
	SITUACAO_SOLICITACAO_REJEITADA_GESTOR_PLATAFORMA,
	SITUACAO_SOLICITACAO_CONFIGURANDO_PASTA_SEGURA
];

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

const initialState = {
	criterioPesquisa: {
		cedente: '',
    	conjuntoArquivosGV : '',
		ativos: true,
		situacao: '',
		numero: '',
		mostraHistorico: false,
	},
	resultadoPesquisa: [],
	situacoes: [...todasSituacoes],
	cedenteDosDados: [],
    arquivos: [],
	pesquisaExecutada: false,
	exibeModalAtivar: false,
	exibeModalInativar: false,
	botoesHabilitados : true,
	exibeModalConfirmacao: false,
};

export const ArquivoGrandesVolumesList =

// router
withRouter(
// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(
	class extends Component {
	
		constructor(props){
			super(props);
			this.state = initialState;

			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleCedenteChange = this.handleCedenteChange.bind(this);
			this.handleConjuntoDeArquivosGVChange = this.handleConjuntoDeArquivosGVChange.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
			this.liberarSolicitacaoAssinatura = this.liberarSolicitacaoAssinatura.bind(this);
			this.confirmaOperacao = this.confirmaOperacao.bind(this);
			this.fechaModal = this.fechaModal.bind(this);
			this.handleOkModais = this.handleOkModais.bind(this);
			this.mostraRelatorioCSV = this.mostraRelatorioCSV.bind(this);
			this.mostraRelatorioPDF = this.mostraRelatorioPDF.bind(this);		
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					
					<div style={{margin: "10px"}}>
						<h1>Solicitações de Cadastro de Arquivos de Grandes Volumes</h1>
					</div>
					
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			const user = this.props.user;

			this.props.limpaMensagem();
			if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			}

			if (user.isAdministrador || user.isMantenedor) {
			api.get('/api/orgao/fornecedores-arquivo-gv')
				.then(response => { this.setState({cedenteDosDados: response.data}) })
			.catch(erro => {
			 	console.log("Não foi possível recuperar os órgãos fornecedores de arquivos GV" + erro)
			 	this.props.exibeMensagemErro("Erro durante o carregamento da página")
			 });
			} else {
				this.setState({
					criterioPesquisa: {
						...this.state.criterioPesquisa,
						cedente: this.props.user.idOrgao ?? '',
					},
					cedenteDosDados: this.props.user.idOrgao ? [{id: this.props.user.idOrgao, nome: this.props.user.nomeOrgao}] : []
				});
			}

			api.get(`/api/conjunto-arquivo-gv/orgao/perfil-usuario`)
				.then(response => { this.setState({arquivos: response.data}) })
			.catch(erro => {
			 	console.log("Não foi possível recuperar os conjuntos de arquivos" + erro)
			 	this.props.exibeMensagemErro("Erro durante o carregamento da página")
			 });			
		}

		renderForm() {
			const { 
				criterioPesquisa, resultadoPesquisa, pesquisaExecutada, situacoes, mostraHistorico
			} = this.state;

			const { numero, cedente, conjuntoArquivosGV, situacao } = criterioPesquisa;
			const { content } = resultadoPesquisa;
			const exibeBotoes = content && content.length > 0;
			const user = this.props.user;

			return(
				<div className="container-fluid">

					<ConfirmationModal titulo="Confirmação" 
						isOpen={this.state.exibeModalConfirmacao}
						onConfirm={() => this.executaOperacao()}
						onClose={() => this.fechaModal()}
						message={this.state.msgModal}/>

					<div className="br-form">
						<div className="row">

							<div className="col-12">
								<div className="field">
									<div className="input">
										<label>Número solicitação:</label>
										<input type="text" name="numero" 
											value={numero}  
											onChange={this.handleInputChange} maxLength={11}/>
										
									</div>
								</div>
							</div>

							<div className="col-12">
								<div className="field">
									<div className="input">
										<label htmlFor='cedente'>Cedente dos Dados:</label>
											<SelectSearch
												id="cedente"
												name="cedente"
												options={this.state.cedenteDosDados.map(cedente => ({ value: cedente.id, label: cedente.nome }))}
												includeAllOption={true}
												onChange={this.handleCedenteChange}
												value={cedente}
												disabled={!user.isAdministrador && !user.isMantenedor}
											/>
									</div>
								</div>
							</div>
							
							<div className="col-12">
								<div className="field">
									<div className="input">
										<label htmlFor='conjuntoArquivosGV'>Conjunto de Arquivos:</label>
											<SelectSearch
												id="conjuntoArquivosGV"
												name="conjuntoArquivosGV"
												options={this.state.arquivos.map(arquivo => ({ value: arquivo.id, label: `${arquivo.titulo} (${arquivo.nomeOrgao})` }))}
												includeAllOption={true}
												onChange={this.handleConjuntoDeArquivosGVChange}
												value={conjuntoArquivosGV}
											/>
									</div>
								</div>
							</div>

							<div className="col-12">
								<div className="field">
									<div className="input">
										<label htmlFor="situacao">Situação:</label>
										<SelectSearch
											id="situacao"
											name="situacao"
											options={situacoes.map(situacao => ({ value: situacao.id, label: situacao.nome }))}
											includeAllOption={true}
											allOptionName="Todas"
											onChange={this.handleInputChange}
											value={situacao}
										/>
									</div>
								</div>
							</div>
							
							<div className="col-sm">
								<div className="check">
									<div className="input">
										<input type="checkbox" name="mostraHistorico" checked={mostraHistorico} onChange={this.handleInputChange} />
										<label>Mostrar histórico da solicitação no relatório CSV</label>
									</div>
								</div>
							
						</div>
						</div>
						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={() => this.pesquisar()} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioPDF} disabled={!this.state.botoesHabilitados}>Relatório PDF</button>}
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioCSV} disabled={!this.state.botoesHabilitados}>Relatório CSV</button>}
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								{user.isCliente &&
									<Link to="/arquivo-grandes-volumes/new"> 
										<button type="button" className="button is-secondary mr-3" disabled={!this.state.botoesHabilitados}>Novo</button>
									</Link>
								}
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
					
						{(content && content.length > 0) &&	
							<div className="br-table">						
								<div className="table">
									<table>
										<thead>
											<tr>
											<th scope="col">Número</th>
											<th scope="col">Cedente</th>
											<th scope="col">Título do conjunto de arquivos</th>
											<th scope="col">Situação</th>
											<th scope="col">Último andamento</th>
											<th className="text-center" scope="col">Ações</th>
											</tr>
										</thead>
										
										<tbody>
											{ content.map((solicitacao, index) =>
													<tr key={index} >
													
													<td>{solicitacao.numero}</td>
														<td>{solicitacao.nomeOrgao}</td>
														<td>{solicitacao.titulo}</td>
														<td>
															{solicitacao.nomeSituacao}
														</td>
														<td>
															{solicitacao.dataUltimoAndamento}
														</td>
														<td className="text-center">
															<div className="actions">
																{ solicitacao.aprovacaoAdministradorPermitida &&
																	<Link to={`/arquivo-grandes-volumes/approve/${solicitacao.id}`}>
																		<button type="button" 
																				disabled={!this.state.botoesHabilitados}  
																				title="Aprovar ou rejeitar a solicitação de cadastro de arquivos de grandes volumes">
																			<span className="sr-only">Aprovar ou rejeitar a solicitação de cadastro de arquivos de grandes volumes</span>
																			<FontAwesomeIcon icon={faClipboardCheck} style={{color: "#1351b4"}} />
																		</button>
																	</Link>
																}
																
																{ solicitacao.visualizacaoPermitida &&
																	<Link to={`/arquivo-grandes-volumes/view/${solicitacao.id}`}>
																		<button type="button" disabled={!this.state.botoesHabilitados} title="Visualizar a solicitação de cadastro de arquivos de grandes volumes">
																			<span className="sr-only">Visualizar a solicitação de cadastro de arquivos de grandes volumes</span>
																			<FontAwesomeIcon icon={faMagnifyingGlass} style={{color: "#1351b4"}} />
																		</button>
																	</Link>
																}

																{ solicitacao.criacaoSolicitacaoAlteracaoConjuntoPermitida &&
																	<Link to={`/arquivo-grandes-volumes/edit-conjunto-gv/${solicitacao.conjuntoArquivo}`}>
																		<button type="button" disabled={!this.state.botoesHabilitados} title="Criar solicitação para alterar o cadastro de arquivos de grandes volumes">
																			<span className="sr-only">Criar solicitação para alterar o cadastro de arquivos de grandes volumes</span>
																			<FontAwesomeIcon icon={faFilePen} style={{color: "#1351b4"}} />
																		</button>
																	</Link>
																}

																{ solicitacao.liberacaoAnalisePermitida &&
																	<button type="button" onClick={() => this.confirmaOperacao(solicitacao, this.liberarSolicitacaoAssinatura, "Deseja realmente liberar a solicitação para análise?")}  
																			disabled={!this.state.botoesHabilitados}  
																			title="Liberar a solicitação de cadastro de arquivos de grandes volumes para análise">
																		<span className="sr-only">Liberar a solicitação de cadastro de arquivos de grandes volumes para análise</span>
																		<FontAwesomeIcon icon={faArrowTrendUp} style={{color: "#1351b4"}} />
																	</button>
																}

																{ user.isMantenedor && solicitacao.configuracaoPastaSeguraPermitida &&
																	<Link to={`/arquivo-grandes-volumes/pasta-segura/${solicitacao.id}`}>
																		<button type="button" disabled={!this.state.botoesHabilitados} title="Registrar informações de configuração da Pasta Segura">
																			<span className="sr-only">Registrar informações de configuração da Pasta Segura</span>
																			<FontAwesomeIcon icon={faFolderClosed} style={{color: "#1351b4"}} />
																		</button>
																	</Link>
																}
																

																{ solicitacao.alteracaoPermitida &&  
																	<Link to={`/arquivo-grandes-volumes/edit/${solicitacao.id}`}>
																		<button type="button" disabled={!this.state.botoesHabilitados} title="Editar a solicitação de cadastro de arquivos de grandes volumes">
																			<span className="sr-only">Editar a solicitação de cadastro de arquivos de grandes volumes</span>
																			<i className="fas fa-edit"></i>
																		</button>
																	</Link>
																}

															</div>
														</td>
													</tr>
												)}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (! content || content.length === 0)) &&
							<div>
								Nenhum arquivo de grandes volumes encontrado com os critérios informados.
							</div>
						}
					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;
			
			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa[nome] = valor;
			this.setState({ criterioPesquisa });
		}

		handleCedenteChange(evento){
			const target = evento.target;
			const valor = target.value;
			
			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa.cedente = valor;
			criterioPesquisa.conjuntoArquivosGV = '';
			
			if (valor) {
				api.get(`/api/conjunto-arquivo-gv/orgao/perfil-usuario?idOrgao=${valor}`)
					.then(response => { 
						this.setState({
							criterioPesquisa,
							arquivos: response.data
						});
					})
					.catch(erro => {
						console.log("Não foi possível recuperar os conjuntos de arquivos: " + erro);
						this.setState({
							criterioPesquisa,
							arquivos: []
						});
					});
			} else {
				api.get(`/api/conjunto-arquivo-gv/orgao/perfil-usuario`)
					.then(response => { 
						this.setState({
							criterioPesquisa,
							arquivos: response.data
						});
					})
					.catch(erro => {
						console.log("Não foi possível recuperar os conjuntos de arquivos: " + erro);
						this.setState({
							criterioPesquisa,
							arquivos: []
						});
					});
			}
		}

		handleConjuntoDeArquivosGVChange(evento){
			const target = evento.target;
			const valor = target.value;
			
			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa.conjuntoArquivosGV = valor;

			this.setState({ criterioPesquisa });	
		}

		executarPesquisaAnterior() {
			const lastState = this.props.filters[this.props.location.pathname];

			this.setState({
				...initialState,
				...lastState,
				pesquisaExecutada: false,
				resultadoPesquisa: []
			}, () => {
				if (lastState) {
					const lastPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(lastPage);
				}
			});
		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executaPesquisaPaginada (pagina){

			const {numero, cedente, conjuntoArquivosGV, situacao} = this.state.criterioPesquisa;
			const orgao = cedente

			const criterioPesquisa = {numero, orgao, conjuntoArquivosGV, situacao, pagina};
			const url = '/api/solicitacao-cadastro-arquivo-gv/paginado';

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando();
			api(options)
				.then(response => { 
					this.setState({
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}, () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as solicitações de arquivo de grandes volumes. " + erro)
					this.props.exibeMensagemErro("Erro durante a execução da pesquisa")
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

		limparPesquisa(){
			this.setState({
				criterioPesquisa: {
					cedente: (this.props.user.isAdministrador || this.props.user.isMantenedor) ? '' : this.props.user.idOrgao ?? '',
					conjuntoArquivosGV : '',
					ativos: true,
					situacao: '',
					numero: '',
				},
				resultadoPesquisa: {},
				pesquisaExecutada: false,
				exibeModalConfirmacao: false,
				botoesHabilitados : true,
			}, () => {
				this.props.deleteState(this.state, this.props.location.pathname);
			});
		}

		alterarSituacao (cedenteDosDados){ 
			const body = { ativo: !cedenteDosDados.ativo }
			this.setState({botoesHabilitados:false});
			this.props.limpaMensagem();
			this.props.mostraAguardando();
			window.scrollTo(0, 0)

			api.put(`/api/orgao/situacao/${cedenteDosDados.id}`, body)
				.then(response => { 
					this.setState({
						pesquisaExecutada : true,
					}) 
					this.pesquisar();
					let mensagem = cedenteDosDados.ativo === true ? 'Órgão desabilitado com sucesso!' : 'Órgão habilitado com sucesso!';
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const mensagemInicial = 'Não foi possível alterar a situação do órgão.';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);

				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
				});
		}

		handleOkModais () {
			this.alterarSituacao(this.state.orgaoAlvo);
			this.fechaModal();
		}

		confirmaOperacao(solicitacao, operacao, msgModal) {
			this.setState(
				{
					exibeModalConfirmacao: true,
					solicitacaoAlvo: solicitacao,
					operacao,
					msgModal,
				}
			);
		}

		liberarSolicitacaoAssinatura (solicitacao){
			api.put(`/api/solicitacao-cadastro-arquivo-gv/liberar-analise/${solicitacao.id}`)
				.then(response => { 
					this.setState({
						pesquisaExecutada : true,
					}) 
					this.pesquisar();
					this.props.exibeMensagemSucesso("Solicitação de cadastro de arquivo de grandes volumes liberada para análise com sucesso.");
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível liberar a solicitação de cadastro de arquivo de grandes volumes para análise.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
				});
		}
		
		executaOperacao () {
			this.setState({botoesHabilitados:false});
			this.props.limpaMensagem();
			this.props.mostraAguardando();
			window.scrollTo(0, 0)

			this.state.operacao(this.state.solicitacaoAlvo);
			this.fechaModal();
		}

		mostraRelatorioCSV(e){
			this.mostraRelatorio(e, 'csv');
		}

		mostraRelatorioPDF(e){
			this.mostraRelatorio(e, 'pdf');
		}

		mostraRelatorio(e, tipo){
			const { criterioPesquisa } = this.state;
			const url = `/api/solicitacao-cadastro-arquivo-gv/${tipo}`;

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa,
				responseType: 'arraybuffer'
			}

			this.props.mostraAguardando();
			this.setState({botoesHabilitados : false});

			api(options)
				.then((response) => {
					baixarArquivo(new Blob([response.data]), `RelatorioSolicitacoesCadastroArquivoGV.${tipo}`);
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o relatório de solicitações de cadastro de arquivo de grandes volumes';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados : true});
				});
		}

		fechaModal () {
			this.setState(
				{
					exibeModalConfirmacao: false,
					exibeModalAtivar:false,
					exibeModalInativar:false
				}
			);
		}
	}

) // redux
); // router